import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Negotiation } from '@models/negotiation.model';

@Injectable()
export class DueDateNegotiationService {
  baseHref = `${environment.apiUrl}/offers`;

  constructor(private http: HttpClient) {}

  getDueDateNegotiation(offerId: number): Observable<Negotiation> {
    const url = `${this.baseHref}/${offerId}/due-date`;
    return this.http.get<Negotiation>(url);
  }

  /**
   * This is only usable by the handyhander, before the offer is accepted
   */
  initiatePreAcceptanceDueDateNegotiation(
    offerId: number,
    dates: Date[],
  ): Observable<Negotiation> {
    const url = `${this.baseHref}/${offerId}/due-date`;
    return this.http.post<Negotiation>(url, { data: { dates } });
  }

  /**
   * This can be used by both the handyhander and the task owner, to initiate a (re)negotiation
   */
  initiateDueDateNegotiation(
    offerId: number,
    date: Date,
    message?: string,
  ): Observable<Negotiation> {
    const url = `${this.baseHref}/${offerId}/due-date`;
    return this.http.post<Negotiation>(url, { message, data: { date } });
  }

  editDueDateNegotiation(
    offerId: number,
    {
      message,
      data,
    }: { message?: string; data?: { date: Date } | { dates: Date[] } },
  ): Observable<Negotiation> {
    if (!message && !data) {
      return throwError(
        () => new Error('Message, data, or both must be provided'),
      );
    }

    const url = `${this.baseHref}/${offerId}/due-date`;
    return this.http.put<Negotiation>(url, { message, data });
  }

  counterDueDateNegotiation(
    offerId: number,
    date: Date,
    message?: string,
  ): Observable<Negotiation> {
    const url = `${this.baseHref}/${offerId}/due-date/counter`;
    return this.http.post<Negotiation>(url, { date, message });
  }

  agreeDueDateNegotiation(
    offerId: number,
    date: Date,
  ): Observable<Negotiation> {
    const url = `${this.baseHref}/${offerId}/due-date/agree`;
    return this.http.post<Negotiation>(url, { date });
  }
}
